
// UI Event Handling for Designer


function safeAddListener(id, event, handler) {
    const el = document.getElementById(id);
    if (el) {
        el.addEventListener(event, handler);
    } else {
      //console.log("safeAddListener: Element with id " + id + " not found for event " + event);
    }
}


function initButtons() {
  //console.log("initButtons");

  // 3rd drop down menu (Text)
  safeAddListener("edit_duplicate", "click", () => duplicateNode());
  safeAddListener("edit_delete", "click", () => handleDeleteItem());
  safeAddListener("edit_ungroup", "click", () => {
    //console.log("edit_ungroup clicked");
    if (app.getSelectedNode()) app.ungroupNode(app.getSelectedNode());
  });

  // 4th drop down menu ( Edit )
  safeAddListener("align_center", "click", () => app.centerNodeInBaseImage());
  safeAddListener("edit_flip_horizontal", "click", () => app.flipHorizontal(app.getSelectedNode()));
  safeAddListener("edit_flip_vertical", "click", () => app.flipVertical(app.getSelectedNode()));
  
  safeAddListener("edit_move_down", "click", () => {
    if (app.getSelectedNode()) app.moveSelectedNodeDown();
  });

  safeAddListener("edit_move_up", "click", () => {
    if (app.getSelectedNode()) app.moveSelectedNodeUp();
  });

  safeAddListener("edit_layers", "click", () => {
    if (app.getSortableNodes().length > 1) {
      app.editLayers();
    } else {
      showMessage("Notice", "You must add some Text, Shapes or Images first");
    }
  });

  safeAddListener("about_help", "click", () => {
      const d = document.getElementById("helpDialog");
      if(d) d.showModal();
  });

  safeAddListener("about_quote", "click", () => {
      const d = document.getElementById("quoteFormDialog");
      if(d) d.showModal();
  });

  let subMenuItems = document.querySelectorAll(".top-toolbar .submenu-item");
  subMenuItems.forEach((item) => {
    item.addEventListener("click", () => {
      let openMenu = document.querySelector(".dropdownmenu-container.show");
      if (openMenu) {
        openMenu.classList.remove("show");
      }
    });
  });


}


function initDropdownMenus() {
  // For Down Down Menus
  const dropdownToggles = document.querySelectorAll('.dropdownmenu-toggle');

  dropdownToggles.forEach((dropdownToggle) => {
    const dropdownContainer = dropdownToggle.parentNode;

    dropdownToggle.addEventListener('click', function () {
      // Toggle the 'show' class on the container to display/hide the menu
      dropdownContainer.classList.toggle('show');
      // Toggle 'active' class on the button to rotate the arrow
      dropdownToggle.classList.toggle('active');

      // Update aria-expanded attribute for accessibility
      const isExpanded = dropdownToggle.getAttribute('aria-expanded') === 'true';
      dropdownToggle.setAttribute('aria-expanded', !isExpanded);
    });

    // Close the dropdown if the user clicks outside of it
    document.addEventListener('click', function (event) {
      if (!dropdownContainer.contains(event.target)) {
        dropdownContainer.classList.remove('show');
        dropdownToggle.classList.remove('active');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
}


function initSidebar() {
  const sidebar = document.getElementById('sidebar');
  const toggleBtn = document.getElementById('toggleBtn');
  const expandAll = document.getElementById('expandAll');
  const themeToggle = document.getElementById('themeToggle');
  const html = document.documentElement;

  if (!sidebar) 
    return; // Basic safety

  // Dark Mode
  const saved = localStorage.getItem('theme') || (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  html.dataset.theme = saved;
  if (themeToggle) {
    themeToggle.innerHTML = saved === 'dark' ? '<i class="fas fa-sun"></i>' : '<i class="fas fa-moon"></i>';
    themeToggle.onclick = () => {
      const isDark = html.dataset.theme === 'dark';
      const newTheme = isDark ? 'light' : 'dark';
      html.dataset.theme = newTheme;
      localStorage.setItem('theme', newTheme);
      themeToggle.innerHTML = newTheme === 'dark' ? '<i class="fas fa-sun"></i>' : '<i class="fas fa-moon"></i>';
    };
  }

  // Sidebar Toggle
  if (toggleBtn) {
    toggleBtn.onclick = () => {
      sidebar.classList.toggle('collapsed');
      toggleBtn.innerHTML = sidebar.classList.contains('collapsed') ? '<i class="fas fa-times"></i>' : '<i class="fas fa-bars"></i>';
    };
  }

  // Accordion + Auto-Expand
  document.querySelectorAll('.accordion-title').forEach(h => {
    h.onclick = () => {
      const body = document.getElementById(h.dataset.target);
      if (body) {
        const open = !body.classList.contains('open');
        body.classList.toggle('open');
        h.classList.toggle('open');
        if (open && sidebar.classList.contains('collapsed')) {
          sidebar.classList.remove('collapsed');
            if(toggleBtn) toggleBtn.innerHTML = '<i class="fas fa-bars"></i>';
          }
      }
    };
  });

  // Expand All
  if (expandAll) {
    let expanded = false;
    expandAll.onclick = () => {
      expanded = !expanded;
      document.querySelectorAll('.accordion-body').forEach(b => b.classList.toggle('open', expanded));
      document.querySelectorAll('.accordion-title').forEach(h => h.classList.toggle('open', expanded));
      expandAll.innerHTML = expanded ? '<i class="fas fa-compress-arrows-alt"></i>' : '<i class="fas fa-expand-arrows-alt"></i>';
      if (expanded && sidebar.classList.contains('collapsed')) {
        sidebar.classList.remove('collapsed');
        if (toggleBtn) toggleBtn.innerHTML = '<i class="fas fa-bars"></i>';
      }
    };
  }

  // Form Demo
  document.querySelector('.form-demo')?.addEventListener('submit', e => {
    e.preventDefault();
    alert('Form submitted!');
  });
}


document.addEventListener("keydown", (event) => {
  if (app.getSelectedNode() && document.activeElement.tagName.toLowerCase() !== 'input' && document.activeElement.tagName.toLowerCase() !== 'textarea') {
    const step = event.shiftKey ? 10 : 1;
    let change = false;

    if (event.key === "ArrowLeft") {
      app.getSelectedNode().x(app.getSelectedNode().x() - step);
      change = true;
    } else if (event.key === "ArrowRight") {
      app.getSelectedNode().x(app.getSelectedNode().x() + step);
      change = true;
    } else if (event.key === "ArrowUp") {
      app.getSelectedNode().y(app.getSelectedNode().y() - step);
      change = true;
    } else if (event.key === "ArrowDown") {
      app.getSelectedNode().y(app.getSelectedNode().y() + step);
      change = true;
    }

    if (change) {
      event.preventDefault();
      app.getLayer().batchDraw();
      updateProperties();
    }
  }
});




// Pick Main Board
document.addEventListener("DOMContentLoaded", () => {
  //console.log("DOMContentLoaded Pick Main Board");
  
  const boardImages = document.querySelectorAll(".boardImage");
  //console.log("boardImages", boardImages);
  boardImages.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      //console.log("boardImage clicked", evt.target);

      //debugger;
      let curBoardImage = app.getBoardImage();
      if (curBoardImage) {
        //layer.children[0].destroy();
        console.log("boardImage destroyed", curBoardImage);
        curBoardImage.destroy();
        app.getLayer().draw();
      }
      //console.log("boardImage clicked", evt.target);
      app.baseBoard = app.getBaseBoard(evt.target.dataset.name);
      app.loadBaseImage(evt.target.dataset.image);
      app.setBaseBoardConfig(evt.target.dataset);

      //console.log("baseBoard", baseBoard);
      if (app.getTrack() != null && baseBoard.can_choose_track === false) {
        app.destroyTrack();
      }

      document.getElementById("boardsDialog").close();
    });
  });


  // Pick SVG Object
  const svgobjects = document.querySelectorAll(".svgobject");
  svgobjects.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      document.getElementById("svgObjectsDialog").close();
      document.getElementById("tracksDialog").close();

      if (evt.target.dataset.group != "Tracks" || (evt.target.dataset.group == "Tracks" && app.getCanAddTrack() == true)) {
        //console.log("add svg object", evt.target.src, evt.target.dataset);
        let url = new URL(evt.target.src);
        //console.log("add svg object url", url);
        //console.log("type", getFileExtension(url.pathname));
        let objType = getFileExtension(url.pathname);

        if (objType === "svg") {
          addSVGImageFromURL(evt.target.src, evt.target.dataset);
        } else {
          app.addTrackImage(url.origin + url.pathname, evt.target.dataset);
        }
      } else {
        showMessage("Notice", "This cribbage board does not allow for custom tracks");
      }
    });
  });


  // Pick SVG Cutout
  const svgcutouts = document.querySelectorAll(".svgcutout");
  svgcutouts.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      document.getElementById("svgCutoutsDialog").close();
      //document.getElementById("tracksDialog").close();

      if (evt.target.dataset.group != "Tracks" || (evt.target.dataset.group == "Tracks" && app.getCanAddTrack() == true)) {
        let curLayer = app.getLayerByClassName("Cutout");
        if (curLayer != null) {
          curLayer.destroy();
        }

        addSVGImageFromURL(evt.target.src, evt.target.dataset);
      } else {
        showMessage("Notice", "This cribbage board does not allow for custom tracks");
      }
    });
  });

  // Pick Design Object
  const designobjects = document.querySelectorAll(".designobject");
  designobjects.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      document.getElementById("designsDialog").close();

      app.fileMenu.newDesign();
      app.fileMenu.loadPrebuiltDesign(evt.target.dataset.title);
    });
  });


});





// Add handler for accordion headers
document.addEventListener("DOMContentLoaded", () => {
  //console.log("DOMContentLoaded accordion");
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      // Get the parent accordion item
      const accordionItem = header.closest(".accordion-item");
      if (!accordionItem) return; // Should not happen if HTML is correct

      const accordionContent =
        accordionItem.querySelector(".accordion-content");
      const accordionIcon = header.querySelector(".accordion-icon");

      // Toggle the 'active' class on the header
      header.classList.toggle("active");

      // Toggle the 'show' class on the content
      if (accordionContent.classList.contains("show")) {
        // If it's currently shown, hide it
        accordionContent.classList.remove("show");
        // Set max-height to 0 to trigger the CSS transition
        //accordionContent.style.maxHeight = null; // Reset to allow transition
      } else {
        // If it's hidden, show it
        accordionContent.classList.add("show");
        // Set max-height to its scrollHeight to enable smooth transition
        // This value needs to be large enough to contain all content.
        // Using scrollHeight is the most precise way for autoLoadDesign === true-height transitions. {
        //accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      }

      // Optional: Close other open accordion items (uncomment if desired)
      accordionHeaders.forEach((otherHeader) => {
        const otherAccordionItem = otherHeader.closest(".accordion-item");
        if (otherAccordionItem !== accordionItem) {
          otherHeader.classList.remove("active");
          const otherContent = otherAccordionItem.querySelector(".accordion-content");
          otherContent.classList.remove("show");
          otherContent.style.maxHeight = null;
        }
      });
    });
  });
});


function showMessage(label, copy) {
  let dialogEl = document.getElementById("messageDialog");
  let labelEl = dialogEl.querySelector("#messageLabel");
  let copyEl = dialogEl.querySelector("#messageCopy");

  labelEl.innerHTML = "<b>" + label + "</b>";
  copyEl.innerHTML = "<p>" + copy + "<br><br></p>";

  dialogEl.showModal();
}


document.getElementById("align").addEventListener("change", function () {
  let sel = app.getSelectedNode();
  let align = document.getElementById("align").value;

  if (sel) {
    sel.setAlign(align);
  }
});



/*
document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("fontFamily").addEventListener("change", function () {
    fontChange();
  });
});
*/


function fontChange() {
  let sel = app.getSelectedNode();
  let external = document.getElementById("fontFamily").getAttribute("data-external");
  //console.log("New Font", fontSelect.value);

  let ffSelect = document.getElementById('fontFamily');
  let ffSelected = ffSelect.options[ffSelect.selectedIndex];
  let ffExternal = ffSelected.getAttribute('data-family');
  //console.log("family", ffSelected.value, ffExternal);
  lastFont = ffSelected.value;

  if (sel) {
    //if (sel.fontFamily != undefined) {
    if (ffExternal !== null) {
      //console.log("Loading Google Font")
      loadGoogleFont(ffExternal, ffSelected.value);

      //console.log("Loaded Google Font")
      app.getLayer().batchDraw();
      //console.log("Redraw After Loaded Google Font")
    } else {
      sel.setFontFamily(ffSelected.value);
      app.getLayer().batchDraw();
    }
    //}
  }
} 


async function loadGoogleFont(family, name) {
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = "https://fonts.googleapis.com/css2?display=swap&family=" + family;
  link.onload = () => {
    //console.log('loadGoogleFont Loaded');

    let sel = app.getSelectedNode();
    if (sel) {
      //console.log('setTimeout Google Font', name);
      sel.setFontFamily(name);
      //layer.batchDraw();
      setTimeout(() => {
        app.getLayer().batchDraw();
      }, 500);
    }

  };
  document.getElementsByTagName('head')[0].appendChild(link);
}





document.addEventListener("DOMContentLoaded", () => {

  // Dialog drag functionality
  let draggedDialog = null;
  let initialX, initialY;

  // Attach drag listeners to all dialog headers
  const dialogHeaders = document.querySelectorAll('dialog .dialog-label');

  dialogHeaders.forEach(header => {
    header.style.cursor = 'grab'; // Visual cue that it's draggable

    header.addEventListener('mousedown', (e) => {
      draggedDialog = header.closest('dialog');

      if (draggedDialog) {
        // Initialize translation state if not present
        if (!draggedDialog.dataset.translateX) draggedDialog.dataset.translateX = 0;
        if (!draggedDialog.dataset.translateY) draggedDialog.dataset.translateY = 0;

        const currentX = parseFloat(draggedDialog.dataset.translateX);
        const currentY = parseFloat(draggedDialog.dataset.translateY);

        initialX = e.clientX - currentX;
        initialY = e.clientY - currentY;

        header.style.cursor = 'grabbing';
      }
      e.preventDefault(); // Prevent text selection
    });
  });

  document.addEventListener('mousemove', (e) => {
    if (draggedDialog) {
      e.preventDefault();

      const currentX = e.clientX - initialX;
      const currentY = e.clientY - initialY;

      draggedDialog.dataset.translateX = currentX;
      draggedDialog.dataset.translateY = currentY;

      requestAnimationFrame(() => {
        if (draggedDialog) {
          draggedDialog.style.transform = `translate(${currentX}px, ${currentY}px)`;
        }
      });
    }
  });

  document.addEventListener('mouseup', () => {
    if (draggedDialog) {
      const header = draggedDialog.querySelector('.dialog-label');
      if (header) header.style.cursor = 'grab';
      draggedDialog = null;
    }
  });

});

// Initialize dialog position
//dialog.style.position = 'absolute';
//dialog.style.transform = `translate(${currentX}px, ${currentY}px)`;

